import { toRef } from 'vue'
import { FIELD_TYPE_CHOICE, FIELD_TYPE_ENUM, FIELD_TYPE_IDENTITY_TYPE } from '../components/js/Constants/FieldType'
import get from 'lodash/get'
import set from 'lodash/set'

export default function ({ def = {}, data = {} } = {}) {
  const defRef = toRef(def)
  const dataRef = toRef(data)

  function setFormDef(value) {
    defRef.value = value
  }

  function setFormData(value) {
    dataRef.value = value
  }

  function isFieldDisplayed(field) {
    return getField(field)?.options.display ?? false
  }

  function setDisabled(field, disabled) {
    const config = getField(field)
    if (!config) {
      return
    }

    set(config, 'options.disabled', disabled)
  }

  function setFieldValue(field, value) {
    set(dataRef.value, field, value)
  }

  function getField(field) {
    return get(defRef.value, field, null)
  }

  // TODO: Should be moved to useSelectField()
  function addSelectOption(field, option) {
    const config = getField(field)
    if (
      FIELD_TYPE_IDENTITY_TYPE !== config?.type && // Special case because it's a text type with choices 🤷
      (FIELD_TYPE_CHOICE !== config?.mainType || FIELD_TYPE_ENUM === config?.type)
    ) {
      return
    }

    if (config.options.ajax) {
      config.options.choices = config.options.choices ?? []
    }

    if (!Array.isArray(config.options.choices)) {
      return
    }

    const containsOption = !!config.options.choices.find((existingOption) => existingOption.id === option.id)
    if (!containsOption) {
      config.options.choices.push(option)
    }
  }

  return {
    def: defRef,
    data: dataRef,
    setFormDef,
    setFormData,
    isFieldDisplayed,
    getField,
    addSelectOption,
    enableField: (field) => setDisabled(field, false),
    disableField: (field) => setDisabled(field, true),
    setFieldValue,
  }
}
